import {blue, red} from '@mui/material/colors';
import {theme} from './styles.js';

export const MAX_TITLE_LENGTH = 128;
export const MAX_DESCRIPTION_LENGTH = 1024;

export const MIN_FRAMES = 2;
export const MAX_FRAMES = 120;
export const MAX_ZOOM = 18;
export const MAX_LIMITED_ACCESS_ZOOM = 12;
export const MAX_GEOMETRY_AREA = 2500; // Maximum area in square km
export const GEO_PROJECTION = 'EPSG:4326';
export const WGS84_PROJECTION = 'EPSG:3857';
export const DEFAULT_EXTENT = [-180, -85, 180, 85];

export const SORT_DIRECTION_ASC = 'asc';
export const SORT_DIRECTION_DESC = 'desc';

export const STORY_WIDTH = 960;
export const ASPECT_RATIO = 16 / 9;
export const FRAME_PADDING = theme.spacing(4);

export const PENDING_STATUSES = ['Pending', 'Generating'];

export const VIEWER_EVENT = 'Story interaction';

export const ITEM_TYPES = {
  PSScene: {
    name: 'PlanetScope',
    abbreviation: 'PS',
    color: theme.palette.primary.main,
    selected: true,
  },
  REOrthoTile: {
    name: 'RapidEye',
    abbreviation: 'RE',
    color: red[500],
    selected: false,
  },
  SkySatScene: {
    name: 'SkySat',
    abbreviation: 'SS',
    color: blue[500],
    selected: false,
  },
};
